import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import css from './SafetyCenterPage.module.css';
import safety1 from './Logo_Hilfetelefon.jpg';
import safety2 from './safety2.jpeg';

const SafetyCenterPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  // prettier-ignore
  return (
    <StaticPage
      title="Safety Center"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'SafetyCenterPage',
        description: 'Safety Center',
        name: 'Safety Center',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain className={css.staticPageWrapper}>
          <center><h1>Schutz und Fürsorge</h1></center>

          <p className={css.subtitle}>
            Wichtiger Hinweis zum Schutz vor sexualisierter Gewalt in Privaten Quartieren
          </p>

          <p style={{ marginTop: 0 }}>
            Die Privaten Quartiere, die über diese Plattform während des Deutschen Evangelischen Kirchentages vermittelt werden, sind eigenständig organisiert und stehen in keinem direkten Zusammenhang mit dem Deutschen Evangelischen Kirchentag. Dementsprechend erfolgt keine Überprüfung der Übernachtungsangebote hinsichtlich ihrer Sicherheit durch den Kirchentag.
            Es ist uns dennoch wichtig, dass alle Beteiligten auch in den Privaten Quartieren in einer Atmosphäre von Respekt und Sicherheit teilnehmen können. Hier sind wichtige Hinweise, um sich vor sexualisierter Gewalt und Diskriminierung zu schützen:
          </p>

          <p>
            <strong>(1) Vorgespräch führen:</strong><br />
            Wir empfehlen allen Gästen und Gastgeber:innen, vorab in einem persönlichen Gespräch (telefonisch oder per Videochat) offene Fragen zu klären und ein Gefühl für die andere Person zu bekommen. Dieses Gespräch kann helfen, Vertrauen aufzubauen und eventuelle Unsicherheiten anzusprechen.
          </p>

          <p>
            <strong>(2) Klare Absprachen treffen:</strong><br />
            Kläre deine Erwartungen an das Miteinander in den Privaten Quartieren. Dies kann beinhalten, welche Räume gemeinsam genutzt werden, was die späteste Ankunftszeit ist und andere Details des Aufenthalts. Transparenz stärkt das gegenseitige Vertrauen und minimiert Missverständnisse. Teile einer nahestehenden Person die Adresse des Quartiers, in der du übernachtest, mit und informiere sie über deinen Aufenthaltszeitraum.
          </p>

          <p>
            <strong>(3) Sicherheitsgefühl prüfen:</strong><br />
            Achte von Anfang an auf dein Gefühl. Solltest du dich bereits im ersten Kontakt oder nach deiner Ankunft unwohl oder bedrängt fühlen, hast du jederzeit das Recht, die Unterkunft zu verlassen! Niemand ist verpflichtet, in einer Situation zu bleiben, die sich unangenehm anfühlt.
          </p>

          <p>
            <strong>(4) Notfallnummern bereithalten:</strong><br />
            Halte eine Liste wichtiger Telefonnummern bereit, z. B. die Notrufnummern der Polizei. Falls du akut Hilfe benötigen oder dich bedrängt fühlst, kontaktiere die Polizei.
          </p>

          <p>
            Wir möchten betonen, dass es Ihr gutes Recht ist, Ihre Sicherheit und Ihr Wohlbefinden jederzeit in den Mittelpunkt zu stellen. Niemand sollte sich verpflichtet fühlen, in einem Privaten Quartier zu verbleiben, in der er oder sie sich unwohl oder bedroht fühlt. Gleiches gilt auch für Gastgeber:innen. Niemand muss Personen bei sich beherbergen, bei denen er oder sie sich unwohl fühlt.
          </p>

          <p>
            Vielen Dank, dass Sie diese Hinweise ernst nehmen und mit uns daran arbeiten, ein sicheres Umfeld zu schaffen.
          </p>

          <p className={css.subtitle} style={{ marginBottom: 32 }}>
            Anlaufstellen im Fall von Gewalt
          </p>

          <div className={css.imagesWrapper}>
            <img src={safety1} className={css.coverImage} />
            <img src={safety2} className={css.coverImage} />
          </div>

          <p style={{ marginTop: 32 }}>
            Im Fall von Gewalt oder anderen Verhaltensauffälligkeiten eines Gastes oder Gastgebers, empfehlen wir die direkte Kontaktaufnahme mit der Polizei und/oder weiteren von der Bundesregierung empfohlen Anlaufstellen wie z. B. Das „Hilfetelefon Gewalt gegen Frauen“ sowie das „Hilfetelefon Gewalt an Männern“.
          </p>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default SafetyCenterPage;
